import React, { FC } from 'react'
import classNames from 'classnames'

import { RightArrowIcon } from './RightArrowIcon'
import { ExternalLinkIcon } from './ExternalLinkIcon'
import { ChannelTypes } from 'pages/ChannelPage/channelType'
import { getTranslatedChannelTypeIndefinite } from 'components/content/RelatedChannel/RelatedChannelItem/getTranslatedChannelTypeIndefinite'
import Shield from '../../assets/images/shield.png'

import styles from './ChannelListItem.module.scss'
import { NATIVE_APP_HELPER } from 'constants/native_app_helper.constants'

interface Props {
  logo: string
  name: string
  sportLabel: string
  rootDomain?: string
  channelType?: ChannelTypes
  showBorder: boolean
}

export const NativeChannelListItem: FC<Props> = ({
  logo,
  name,
  sportLabel,
  rootDomain,
  channelType,
  showBorder
}) => {
  const appDomain = window.location.hostname

  // Note :
  // SOLID_SPORT_APP.IS_SOLIDSPORT_DOMAIN is used to check if the app
  // is running in the Solid Sport domain or not
  const nativeIcon =
    rootDomain === appDomain ||
    NATIVE_APP_HELPER.SOLID_SPORT_APP.IS_CURRENT_DOMAIN ? (
      <RightArrowIcon />
    ) : (
      <ExternalLinkIcon />
    )

  const channelLogoToUse = logo ? logo : Shield
  return (
    <div
      className={classNames(styles.ChannelListItemContainer, {
        [styles.WithExternalLink]: rootDomain,
        [styles.HasBorder]: showBorder
      })}
      data-testid="channel-item"
    >
      <img src={channelLogoToUse} alt={name} className={styles.Logo} />
      <div className={styles.VerticalDivider} />
      <div className={styles.LabelContainer}>
        <div className={styles.Name} data-testid="channel-name">
          {name}
        </div>
        <div className={styles.TagContainer}>
          {sportLabel && <div className={styles.Tag}>{sportLabel}</div>}
          {channelType && (
            <div className={styles.Tag}>
              {getTranslatedChannelTypeIndefinite(channelType)}
            </div>
          )}
        </div>

        {rootDomain && (
          <div className={styles.RootDomainLabel} data-testid="root-domain">
            {rootDomain}
          </div>
        )}
      </div>
      <div className={styles.IconContainer}>{nativeIcon}</div>
    </div>
  )
}
